import createDocumentData from "../../utils/createDocumentData";
import runTransaction from "../../utils/runTransaction";

import { toArticleData } from "../works/data/workArticleFields";
import { WorkMetaData } from "../works/types/WorkMetaData";

import { Article } from "./types/Article";
import updateArticle from "./updateArticle";

export default function createArticle(firebase, data, { transaction, user, ...options } = {}) {
	return runTransaction(
		firebase,
		[data.work?.ref],
		(transaction, [work]) => {
			// If the work exists, add its metadata to the article
			if (work?.exists) {
				data = { ...WorkMetaData.parse(work), ...data, work };
			}

			data = Article.parse(
				createDocumentData(firebase, "articles", { ...toArticleData(data, data.type), createdBy: user }),
			);

			return updateArticle(firebase, data, { ...options, transaction });
		},
		transaction,
	);
}
